import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["typeSelectInput", "templateIdSelectInput"];
  static values = { view: String };

  connect() {
    if (!this.isEditableView()) return;
    this.syncTemplateOptions();
  }

  onTypeChange() {
    this.syncTemplateOptions();
  }

  syncTemplateOptions() {
    if (!this.hasTypeSelectInputTarget || !this.hasTemplateIdSelectInputTarget)
      return;

    const templateSets = this.templateSets();
    const selectedType = this.typeSelectInputTarget.value;
    const options = templateSets[selectedType] || [];

    this.replaceTemplateOptions(options);
  }

  templateSets() {
    const dataset = this.typeSelectInputTarget.dataset;
    return {
      Mailing: this.parseTemplates(dataset.campaignResourceMailingTemplates),
      WhatsApp: this.parseTemplates(dataset.campaignResourceWhatsappTemplates),
    };
  }

  parseTemplates(value) {
    if (!value) return [];

    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  replaceTemplateOptions(options) {
    const select = this.templateIdSelectInputTarget;
    const currentValue = select.value;
    const blankOption = Array.from(select.options).find(
      (option) => option.value === "",
    );

    select.options.length = 0;

    if (blankOption) {
      select.add(blankOption);
    }

    options.forEach(([label, value]) => {
      select.add(new Option(label, value));
    });

    if (
      currentValue &&
      Array.from(select.options).some((option) => option.value === currentValue)
    ) {
      select.value = currentValue;
    }
  }

  isEditableView() {
    return this.viewValue === "new" || this.viewValue === "edit";
  }
}
